import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import ARTICLES from '../data/articles.json';
import { ContentSections, Faq, ProductCards } from './ContentSections';
import { NotFound } from './NotFound';

export const Article = ({ products }) => {
  const { slug } = useParams();
  const article = ARTICLES[slug];

  if (!article) return <NotFound />;

  const url = `https://stamsyart.bg/blog/${slug}`;

  return (
    <>
      <Helmet>
        <title>{article.title}</title>
        <meta name="description" content={article.description} />
        <link rel="canonical" href={url} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={article.title} />
        <meta property="og:description" content={article.description} />
      </Helmet>

      <div className="content-wrap">
        <nav className="catalog-breadcrumb">
          <Link to="/">Начало</Link>
          <span>/</span>
          <Link to="/blog">Полезно</Link>
          <span>/</span>
          <span>{article.h1}</span>
        </nav>

        <h1>{article.h1}</h1>
        {article.published && (
          <p className="article-meta">
            Публикувано на{' '}
            <time dateTime={article.published}>
              {new Date(article.published).toLocaleDateString('bg-BG', {
                day: 'numeric', month: 'long', year: 'numeric',
              })}
            </time>
          </p>
        )}
        {article.lead && <p className="content-lead">{article.lead}</p>}
        {/* Продуктите стоят веднага след въведението – малко хора стигат до края. */}
        <ProductCards ids={article.products} products={products} label="Ръчно изработени в Stamsy Art" />

        <ContentSections sections={article.sections} products={products} />
        <Faq items={article.faq} />

        {article.cta && (
          <div className="content-cta">
            <p>{article.cta.text}</p>
            <Link to={article.cta.href}>{article.cta.linkText}</Link>
          </div>
        )}
      </div>
    </>
  );
};
